module.exports = __webpack_public_path__ + "static/media/blue.aa966b91.png";